import { gql } from '@/__generated__';

const SEND_TEAMS_MESSAGE = gql(/* GraphQL */ `
  mutation SendTeamsMessage($input: SendTeamsMessageInput!) {
    sendTeamsMessage(input: $input) {
      response
    }
  }
`);

export default SEND_TEAMS_MESSAGE;
